import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Attachment } from "../models/attachment";
import randomId  from "alphanumeric-id"
import { environment } from "../environments/environment";
import { RootState } from "./store";

// API Calls Start
const apiSaveAttachment = async (attachment: Attachment, uploadId: string | null, onComplete: (id: string, data: any) => void, file: any) => {
    const baseURL = environment.apiURL;
    const theUploadId = uploadId || randomId(5);
    const response = await axios.post(`${baseURL}/attachments`, { ...attachment }, { params: { fields: ['all', 'uploadURL'], contentType: file.type}});

    if (response.data.uploadURL) {
        const uploadResponse = await axios.put(response.data.uploadURL, file, {
            headers: {
              'Content-Type': response.data.contentType,
              'Content-Disposition': `${response.data.disposition}; filename=${response.data.filename}`,
            },
          });
          onComplete(theUploadId, response.data);
    }
    return response.data;
} 

const apiDeleteAttachment = async (id: number) => {
    const baseURL = environment.apiURL;
    const response = await axios.delete(`${baseURL}/attachments/${id}`);
    return response.data;
}

const apiGetAttachment = async (id: number) => {
    const baseURL = environment.apiURL;
    const response = await axios.get(`${baseURL}/attachments/${id}`);
    return response.data;
}
// API Calls End

// Thunks Start
export const saveAttachment = createAsyncThunk(
    'attachment/save',
    async (params: { attachment: Attachment, uploadId: string | null, onComplete: (id: string, data: any) => void, file: any }, { rejectWithValue }) => {
        try {
            const attachment = await apiSaveAttachment(params.attachment, params.uploadId, params.onComplete, params.file);
            return attachment;
        } catch (error) {
            return rejectWithValue('Failed to save attachment');
        }
    }
);

export const deleteAttachment = createAsyncThunk(
    'attachment/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            const attachment = await apiDeleteAttachment(id);
            return attachment;
        } catch (error) {
            return rejectWithValue('Failed to delete attachment');
        }
    }
);

export const getAttachment = createAsyncThunk(
    'attachment/get',
    async (id: number, { rejectWithValue }) => {
        try {
            const attachment = await apiGetAttachment(id);
            return attachment;
        } catch (error) {
            return rejectWithValue('Failed to get attachment');
        }
    }
);
// Thunks End


// Slice Start
interface AttachmentState {
  isLoading: boolean;
  error: string | null;
}

const initialState: AttachmentState = {
  isLoading: false,
  error: null
};

const attachmentSlice = createSlice({
  name: "attachment",
  initialState,
  reducers: {
 
  },
  extraReducers: (builder) => {
    builder
  },
});
// Slice End

// Export actions and reducer
export const {  } = attachmentSlice.actions;
export default attachmentSlice.reducer;

// Selectors
export const selectAttachmentLoading = (state: RootState) => state.attachment.isLoading;
export const selectAttachmentError = (state: RootState) => state.attachment.error;